var html = require('choo/html')
var { Elements } = require('prismic-richtext')
var { img } = require('../base')
var embed = require('../embed')

module.exports = serialize

function serialize (type, node, content, children) {
  switch (type) {
    case Elements.paragraph: {
      if (node.text === '' || node.text.match(/^\s+$/)) {
        return null
      }
      return null
    }

    case Elements.hyperlink: {
      if (node.data && node.data.link_type === 'Media') {
        if (/\.(wav|mp3)$/.test(node.data.url)) {
          return html`
            <audio controls src="${node.data.url}">Din webblÃÂ¤sare stÃÂ¶djer inte ljud, tyvÃÂ¤rr!</audio>
          `
        }
        return null
      }
      return null
    }

    case Elements.embed: {
      if (!node.oembed.thumbnail_url) return null

      return embed({
        url: node.oembed.embed_url,
        title: node.oembed.title,
        src: node.oembed.thumbnail_url,
        width: node.oembed.thumbnail_width,
        height: node.oembed.thumbnail_height,
        sizes: '42rem'
      })
    }
    case Elements.image: {
      var attrs = {}
      var opts = {}
      if (!/\.(svg|gif)$/.test(node.url)) {
        attrs.sizes = '42rem'
        opts.sizes = [400, 800, 1000, 1200]
      }

      return html`
        <figure>
          ${img(node, attrs, opts)}
          ${node.alt ? html`<figcaption class="Text-caption">${node.alt}</figcaption>` : null}
        </figure>
      `
    }
    default: return null
  }
}
